import type { ReactNode } from 'react';
import { SegmentedControl } from '@mantine/core';
import { IconDeviceMobile, IconMoon, IconSun } from '@tabler/icons-react';
import { THEME_CHOICES, useThemeChoice, type ThemeChoiceValue } from '@/theme/colorScheme';

const ICONS: Record<ThemeChoiceValue, ReactNode> = {
  auto: <IconDeviceMobile size={18} aria-hidden="true" />,
  light: <IconSun size={18} aria-hidden="true" />,
  dark: <IconMoon size={18} aria-hidden="true" />,
};

export interface ThemeChoiceProps {
  /** Visible label above the control. Defaults to "Appearance"; pass null to hide it. */
  label?: ReactNode | null;
  /** Line under the label. */
  description?: ReactNode;
}

/**
 * Appearance setting for Account: "Match my phone" (default), "Light" or "Dark", as a segmented
 * control (real radio inputs). Saved on this device straight away; no Save button needed.
 */
export function ThemeChoice({ label = 'Appearance', description }: ThemeChoiceProps) {
  const { choice, setChoice } = useThemeChoice();
  return (
    <div className="rides-themechoice">
      {label !== null && (
        <div id="rides-theme-choice-label" style={{ fontWeight: 600, fontSize: 16, marginBottom: description ? 2 : 8 }}>{label}</div>
      )}
      {description && <p style={{ margin: '0 0 8px', color: 'var(--rides-muted)', fontSize: 14 }}>{description}</p>}
      <SegmentedControl
        fullWidth
        value={choice}
        onChange={(v) => setChoice(v as ThemeChoiceValue)}
        aria-labelledby={label !== null ? 'rides-theme-choice-label' : undefined}
        aria-label={label === null ? 'Appearance' : undefined}
        data={THEME_CHOICES.map((c) => ({
          value: c.value,
          label: <>{ICONS[c.value]}<span>{c.label}</span></>,
        }))}
      />
    </div>
  );
}
